export const editCardValidate = (
    fileData,
    images,
    loadedImages) => {

    const errors = {}

    if (!fileData.title.trim()) {
        errors.title = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.title
    }

    // if (!fileData.seoTitle?.trim()) {
    //     errors.seoTitle = "لطفا seoTitle را وارد کنید"
    // } else {
    //     delete errors.seoTitle
    // }

    // if (!fileData.seoDescription?.trim()) {
    //     errors.seoDescription = "لطفا seoDescription را وارد کنید"
    // } else {
    //     delete errors.seoDescription
    // }

    // if (!fileData.seoKeywords?.trim()) {
    //     errors.seoKeywords = "لطفا seoKeywords را وارد کنید"
    // } else {
    //     delete errors.seoKeywords
    // }

    // if (!fileData.seoCanonical?.trim()) {
    //     errors.seoCanonical = "لطفا seoCanonical را وارد کنید"
    // } else {
    //     delete errors.seoCanonical
    // }

    // if (!fileData.seoSchema?.trim()) {
    //     errors.seoSchema = "لطفا seoSchema را وارد کنید"
    // } else {
    //     delete errors.seoSchema
    // }

    // if (user == false) {
    //     if (fileData.fileFound === "") {
    //         errors.fileFound = "لطفا فایل یابی را وارد کنید"
    //     } else {
    //         delete errors.fileFound
    //     }
    // }

    // if (!user) {
    //     if (!fileData.commitionPercent.trim()) {
    //         errors.commitionPercent = "لطفا کمسیون را وارد کنید"
    //     } else {
    //         delete errors.commitionPercent
    //     }
    // }

    // if (!fileData.slug.trim()) {
    //     errors.slug = "لطفا عنوان انگلیسی را وارد کنید"
    // } else {
    //     delete errors.slug
    // }

    if (!fileData.meter) {
        errors.meter = "لطفا متراژ را وارد کنید"
    } else {
        delete errors.meter
    }

    if (!fileData.address.trim()) {
        errors.address = "لطفا آدرس را وارد کنید"
    } else {
        delete errors.address
    }
    // if (!fileData.description.trim()) {
    //     errors.description = "لطفا توضیحات را وارد کنید"
    // } else {
    //     delete errors.description
    // }

    // if (!loadedImages) {
    //     if (images == "") {
    //         errors.images = "لطفا حداقل یک عکس را انتخاب نمایید"
    //     } else {
    //         delete errors.images
    //     }
    // }

    // if (!user) {
    //     if (!fileData.commitionPercent.trim()) {
    //         errors.commitionPercent = "لطفا آدرس را وارد کنید"
    //     } else {
    //         delete errors.commitionPercent
    //     }
    // }


    // if (addedFacilities == "") {
    //     errors.addedFacilities = "لطفا امکانات را اضافه کنید"
    // } else {
    //     delete errors.addedFacilities
    // }


    if (fileData.city == "") {
        errors.cityName = "لطفا شهر را انتخاب کنید"
    } else {
        delete errors.cityName
    }

    if (fileData.place == "") {
        errors.placeName = "لطفا منطقه را انتخاب کنید"
    } else {
        delete errors.placeName
    }

    if (fileData.year == "") {
        errors.yearName = "لطفا سال ساخت را انتخاب کنید"
    } else {
        delete errors.yearName
    }

    if (fileData.room === "") {
        errors.roomNumber = "لطفا تعداد اتاق را انتخاب کنید"
    } else {
        delete errors.roomNumber
    }

    if (fileData.floor === "") {
        errors.floorNumber = "لطفا طبقه را انتخاب کنید"
    } else {
        delete errors.floorNumber
    }

    return errors;
}